<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-协议-添加
    -->
    <el-dialog
    title="添加协议"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加协议</div>
      <el-form-item label="协议名称" prop="name"><el-input v-model="form.name" placeholder="请输入协议名称" class="max-w460"></el-input></el-form-item>
      <el-form-item label="自定义协议类型">
        <el-input v-model="form.code" placeholder="请输入自定义协议类型" style="width: 200px;"></el-input>

        <div>实际举例：plus2/pages/xieyi/xieyi?code=user,则会获取类型为user的协议，自定义装修链接可实现该功能</div>
      </el-form-item>

      <el-form-item label="协议" prop="content">
        <div class="edit_container">
          <Uediter v-model="form.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
</el-dialog>
  
</template>

<script>
import XieyiApi from '@/api/xieyi.js';
import Uediter from '@/components/UE.vue';
export default {
  components: {
    /*编辑器*/
    Uediter,
  },
  data() {
    return {
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        content: '',
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入协议名称', trigger: 'blur' }],
      },
      dialogVisible:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","xieyi_id"],
  methods: {

     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      XieyiApi.detail({xieyi_id: self.xieyi_id},true).then(res => {
          self.form = res.data;
          self.form.code =  res.data.code;
          self.ueditor.text = self.form.content;
          self.loading = false;
        })
        .catch(error => {});
    },
    onSubmit() {
      let self = this;
      let form = self.form;
      form.xieyi_id = self.xieyi_id;
      form.content = self.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          XieyiApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":result });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/xieyi/part/edit.vue